import { Reveal, SectionTag } from "@/components/Reveal";

const STEPS = [
  {
    title: "Enquiry & Scoping",
    desc: "We capture specifications, target price, volumes and delivery timelines.",
  },
  {
    title: "Sourcing & Costing",
    desc: "Shortlisted factories quote; we benchmark and present a fully costed proposal.",
  },
  {
    title: "Sampling & Approval",
    desc: "Counter samples developed, revised and signed off as the golden sample.",
  },
  {
    title: "Production & QC",
    desc: "Order placed, production tracked, with in-line and pre-shipment inspection.",
  },
  {
    title: "Export & Delivery",
    desc: "Consolidation, documentation, customs clearance and shipment to your port.",
  },
];

export const Process = () => (
  <section id="process" className="relative py-28 lg:py-40 bg-[#F4F7FC]" data-testid="process-section">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
      <Reveal>
        <SectionTag index="04" label="How We Work" />
      </Reveal>
      <Reveal>
        <h2 className="font-display font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#0A1B33] max-w-3xl mb-24" data-testid="process-heading">
          Five chapters, <span className="text-[#2E7FE0]">enquiry to shipment.</span>
        </h2>
      </Reveal>

      <div>
        {STEPS.map((s, i) => (
          <Reveal key={s.title} delay={0.05}>
            <div
              className="group grid grid-cols-12 gap-6 items-center border-t border-[#2E7FE0]/15 py-10 lg:py-14 transition-colors duration-500 hover:bg-[#2E7FE0]/5"
              data-testid={`process-step-${i}`}
            >
              <div className="col-span-3 lg:col-span-2">
                <span className="font-display font-bold text-6xl lg:text-8xl text-[#2E7FE0] transition-colors duration-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="col-span-9 lg:col-span-4">
                <h3 className="font-display font-semibold text-2xl lg:text-3xl text-[#0A1B33]">{s.title}</h3>
              </div>
              <div className="col-span-12 lg:col-span-6">
                <p className="text-[#54678A] leading-relaxed lg:pl-8">{s.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-[#2E7FE0]/15" />
      </div>

      <Reveal className="mt-12">
        <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#54678A] leading-relaxed" data-testid="process-timeline-note">
          <span className="text-[#2E7FE0]">Typical timeline:</span> 4 to 10 weeks from enquiry to
          shipment — depending on category, sampling cycles and order volume.
        </p>
      </Reveal>
    </div>
  </section>
);
